module.exports = "/fonts/salesforce-sans.woff?c97166adea9a4a772b4c6f8b1fefe72c";